import { motion } from "framer-motion";
import { Copy, ClipboardPaste, Download } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ICONS = [Copy, ClipboardPaste, Download];

export default function HowItWorks() {
  const { t } = useLang();
  const steps = t("howit.steps") || [];

  return (
    <section id="how-it-works" className="relative py-20" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-12"
        >
          {t("howit.title1")} <span className="neon-text-gradient">SS Downloader</span>{t("howit.title2")}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.65, delay: i * 0.14 }}
                className="relative rounded-2xl border border-white/10 bg-surface/70 backdrop-blur-xl p-7 overflow-hidden"
                data-testid={`howit-step-${i}`}
              >
                <span className="absolute -top-3 end-4 font-display text-6xl font-black text-neon/10 select-none" aria-hidden="true">
                  0{i + 1}
                </span>
                <span className="grid place-items-center h-12 w-12 rounded-xl bg-neon/10 border border-neon/30 mb-5">
                  <Icon className="h-6 w-6 text-neon" />
                </span>
                <h3 className="font-bold text-lg mb-2 text-ice">{s.t}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
